import React from 'react'
import { useTranslate } from './TranslationText'
import { useSelector } from 'react-redux';

export default function OnAirHorse({ scrollToTable }) {
    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('ecupLang') ?? 'en';
    const { inArenaHorse, viewHorseBox } = useSelector(state => state.horseOnAir);
    const { data, loading, error } = useSelector(state => state.showTemporaryRank);

    const display_box = data?.length >0 || !!inArenaHorse?.HorseInArenaName;

    return (
        display_box && 
            <div className='bg-success p-3 rounded my-3'>
                <h4 className='text-white' >{translate('web.nowOnAir', 'Now On Air')}</h4>
                {!!inArenaHorse?.HorseInArenaName ? <>
                    <h5 className='text-white text-decoration-underline' style={{ cursor: 'pointer' }} onClick={() => scrollToTable(inArenaHorse?.HorseId)} >{inArenaHorse?.HorseNumber} - {currentLanguage == 'en' ? inArenaHorse?.HorseInArenaName : inArenaHorse?.HorseInArenaNameAr}  </h5>
                    <h5 className='text-white' >{currentLanguage == 'en' ? inArenaHorse?.OwnerName : inArenaHorse?.OwnerNameAr} </h5>
                    <div className='row text-white'>
                        <div className='col-md-12 col-sm-12 col-12'>
                            {translate('web.breeder', 'Breeder')}: {currentLanguage == 'en' ? inArenaHorse?.BreederName : inArenaHorse?.BreederNameAr}
                        </div>
                        <div className='col-md-6 col-sm-12 col-12'>
                            {translate('web.birthDate', 'BirthDate')} {inArenaHorse?.BirthDate}
                        </div>
                        <div className='col-md-6 col-sm-12 col-12'>
                            {translate('web.color', 'Color')}: {currentLanguage == 'en' ? inArenaHorse?.Color : inArenaHorse?.ColorAr}
                        </div>
                        <div className='col-md-6 col-sm-12 col-12'>
                            {translate('web.sire', 'sire')}: {currentLanguage == 'en' ? inArenaHorse?.Sire : inArenaHorse?.SireAr}
                        </div>
                        <div className='col-md-6 col-sm-12 col-12'>
                            {translate('web.dam', 'dam')}: {currentLanguage == 'en' ? inArenaHorse?.Dam : inArenaHorse?.DamAr}
                        </div>
                    </div>
                </> : <>
                    {data?.length > 0 && <>
                        <h5 className='text-white text-decoration-underline' >{currentLanguage == 'en' ? data?.at(-1)?.ClassName : data?.at(-1)?.ClassNameAr} </h5>
                    </>}
                </>}
            </div>
    )
}
